$('.scroll-me').click(function(){
    scroll($(this).attr('href'));
    return false;
});

if($('[data-scroll-to-me]').length) {
    scroll($('[data-scroll-to-me]'));
}

$(window).on('load', function() {
    if (location.hash) {
        var pos = $(location.hash).offset().top - $('main').offset().top - 20;
        $(window).scrollTop(pos);
    }
});


function scroll (element) {
    $('html, body').animate({
        scrollTop: $(element).offset().top - $('main').offset().top - 50 // extra spacing
    }, 800);
}



// WEBPACK FOOTER //
// ./js/modules/_scroll.js